import React from 'react';
import APIConfiguration from './APIConfiguration';

const Integrations = () => {
  return <APIConfiguration />;
};

export default Integrations;